import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import BaseBreadCrumbs from '@base/BreadCrumbs/BreadCrumbs';
import BreadCrumbHelper, { goBack } from '@utils/breadcrumbs';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import { mediaQuery, Spacings } from '@styles/index';
import { getIsSubscribedToOffline } from '@selectors/subscription';
import { useSelector } from 'react-redux';

const StyledBaseBreadCrumbs = styled(BaseBreadCrumbs)`
  margin-bottom: ${Spacings.SPACING_6B};

  ${mediaQuery.uptoMobile} {
    margin-bottom: 0;
    padding-top: ${Spacings.SPACING_4B};
  }
`;

const TYPE = {
  ONLY_TEST_SERIES: 'ONLY_TEST_SERIES',
  TEST_SERIES_WITH_COMBAT: 'TEST_SERIES_WITH_COMBAT'
};

const Breadcrumbs = ({ type, goalDisplayName = '' }) => {
  const router = useRouter();

  const {
    query: { goalSlug, goalUID, 'test-type': testType }
  } = router;

  const isOfflineSubscription = useSelector(getIsSubscribedToOffline(goalUID));

  const { goalInfo: goalDetails } = useGoalInfo(goalUID);

  const resolvedGoalName =
    goalDisplayName || goalDetails?.name || goalDetails?.title;

  const goalForBreadcrumbs =
    goalDetails && resolvedGoalName
      ? { ...goalDetails, name: resolvedGoalName }
      : goalDetails;

  const tags =
    BreadCrumbHelper.getPlusTopicsTags(
      goalForBreadcrumbs,
      isOfflineSubscription
    ) || [];

  if (type === TYPE.ONLY_TEST_SERIES) {
    tags.push({
      title: 'Tests',
      href: `/goal/${goalSlug}/${goalUID}/test-series?test-type=${testType}`
    });
  }

  return (
    <StyledBaseBreadCrumbs tags={tags} onBackClick={goBack} useBackClick />
  );
};

export default Breadcrumbs;

Breadcrumbs.propTypes = {
  type: PropTypes.oneOf([TYPE.ONLY_TEST_SERIES, TYPE.TEST_SERIES_WITH_COMBAT]),
  goalDisplayName: PropTypes.string
};

Breadcrumbs.defaultProps = {
  type: TYPE.TEST_SERIES_WITH_COMBAT
};

Breadcrumbs.TYPE = TYPE;
